"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowUpList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const Formatters_1 = require("../../common/Formatters");
const hui_1 = require("@mit/hui");
const ChangeHoldStatus_1 = __importDefault(require("../holds/ChangeHoldStatus"));
const react_router_dom_1 = require("react-router-dom");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const PersonDetailsDrawer_1 = __importDefault(require("../common/PersonDetailsDrawer"));
const FollowUpListComponent = ({ peopleStore, holds, covidNav, history }) => {
    var _a;
    const [showPerson, setShowPerson] = (0, react_1.useState)(false);
    const [showEdit, setShowEdit] = (0, react_1.useState)(false);
    const [person, setPerson] = (0, react_1.useState)();
    const [editRecord, setEditRecord] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isUnauth, setUnauth] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (peopleStore.followUpList === undefined) {
            setLoading(true);
            reloadDataFollowUp();
        }
    });
    const reloadDataFollowUp = () => __awaiter(void 0, void 0, void 0, function* () {
        covidNav.globalTableIsLoading = true;
        const followUpResponse = yield MedicalApi_1.default.fetchAllHolds();
        if (followUpResponse.error) {
            //todo: handle error
        }
        else if (followUpResponse.unauth) {
            //setLoading(false);
            setUnauth(true);
        }
        else {
            if (followUpResponse.items) {
                setLoading(false);
                peopleStore.setFollowUpList(followUpResponse.items);
                covidNav.globalTableIsLoading = false;
            }
        }
    });
    const viewPersonClose = () => {
        setPerson(undefined);
        setShowPerson(false);
    };
    const editHoldStatusClose = () => {
        setEditRecord(undefined);
        setShowEdit(false);
        setLoading(true);
        reloadDataFollowUp();
    };
    const handlePersonClick = (item) => {
        covidNav.activePage = "search";
        history.push(`/search?krb_name=${item.kerberos}`);
    };
    const showPersonInfo = (item) => {
        setShowPerson(true);
        setPerson(item);
    };
    const getClassName = (status) => {
        if (status.toLowerCase() === 'open') {
            return 'open-status';
        }
        else if (status.toLowerCase() === 'new') {
            return 'new-status';
        }
        return '';
    };
    const columns = [
        {
            id: "display_name",
            name: "Name",
            sortable: true,
            formatter: (item) => {
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "clickable", onClick: () => {
                        showPersonInfo(item);
                    }, tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.display_name }) })));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Name",
            },
            filterable: true,
            filterOptions: {
                type: "textbox",
                onFilter: (item, value) => {
                    if (item.display_name.toLowerCase().indexOf(value.toLowerCase()) != -1)
                        return true;
                    return false;
                },
            }
        },
        {
            id: "vaccination_status",
            name: "Vaccination Status",
            sortable: false,
            formatter: (item) => {
                let iconsOptions = [
                    {
                        status: "none",
                        color: "red",
                        icon: "shield",
                        display: false
                    },
                    {
                        status: "partial",
                        color: "orange",
                        icon: "shield-alt",
                        display: false
                    },
                    {
                        status: "full",
                        color: "green",
                        icon: "shield-check",
                        display: true
                    },
                    {
                        status: "exempt",
                        color: "grey",
                        icon: "comment-check",
                        display: false
                    }
                ];
                let iconCfg = iconsOptions.find(o => o.status === item.vaccination_status);
                return ((0, jsx_runtime_1.jsx)("span", Object.assign({ style: { fontSize: "1.5em" } }, { children: iconCfg && iconCfg.display &&
                        (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "solid", color: iconCfg ? iconCfg.color : 'grey', icon: iconCfg ? iconCfg.icon : "question-square", padded: false }) })));
            },
            options: {
                demandPopin: false,
                popinText: "Vaccination Status",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    if (value)
                        return item.vaccination_status === value;
                    return true;
                },
            },
        },
        {
            id: "phone_number",
            name: "Phone Number",
            sortable: false,
            formatter: (item) => {
                return item.phone_number && (0, jsx_runtime_1.jsx)("a", Object.assign({ href: `tel:${item.phone_number}` }, { children: (0, Formatters_1.formatPhoneNumber)(item.phone_number) }));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Phone Number",
            },
            filterable: false,
        },
        {
            id: "email",
            name: "Email",
            sortable: false,
            formatter: (item) => {
                return ((0, jsx_runtime_1.jsx)("a", Object.assign({ className: "table-email", href: `mailto:${item.email}` }, { children: item.email })));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Email",
            },
            filterable: false,
        },
        {
            id: "created_on",
            name: "Last Updated",
            sortable: true,
            formatter: (item) => {
                return (0, Formatters_1.usDateTime)(item.created_on);
            },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Last Updated",
            },
            filterable: true,
            filterOptions: {
                type: "calendar",
                onFilter: (item, value) => {
                    if (value !== null && value !== undefined && value !== "") {
                        let fromDate = new Date(value.substr(value.indexOf(" ") + 1, value.indexOf("to ") - 6));
                        let toDate = new Date(value.substr(value.indexOf("to ") + 3));
                        toDate.setHours(23);
                        toDate.setMinutes(59);
                        toDate.setSeconds(59);
                        if (fromDate && toDate) {
                            var compareDate = new Date(item.created_on);
                            return compareDate.getTime() >= fromDate.getTime() && compareDate.getTime() <= toDate.getTime();
                        }
                        return true;
                    }
                    return true;
                },
            },
        },
        {
            id: "updated_by",
            name: "Updated by",
            sortable: true,
            formatter: (item) => {
                return item.updated_by ? item.updated_by : item.created_by;
            },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Updated by",
            },
            filterable: false,
        },
        {
            id: "reason",
            name: "Reason",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Reason",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    if (value)
                        return item.reason === value;
                    return true;
                },
            },
        },
        {
            id: "comments",
            name: "Comments",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Comments",
            },
            filterable: false,
        },
        {
            id: "status",
            name: "Status",
            sortable: true,
            formatter: (item) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: getClassName(item.status) }, { children: item.status }))),
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Status",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    if (value)
                        return item.status === value;
                    return true;
                }
            }
        }
    ];
    const actionButtons = [
        {
            icon: "edit",
            type: hui_1.ButtonType.Ghost,
            onClick: (e) => {
                setEditRecord(e);
                setShowEdit(true);
            },
            text: "",
            state: 0,
            padded: false,
        },
    ];
    const data = ((_a = peopleStore.followUpList) === null || _a === void 0 ? void 0 : _a.map(i => i)) || [];
    //const data = peopleStore!.followUpList?.map(i => i).filter(o=> o.reason !== 'Contact') || []
    //console.log('DATA', data, peopleStore!.followUpList);
    if (isUnauth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data ? data : [], showExportButton: false, showFilterButton: true, isLoading: isLoading || covidNav.globalTableIsLoading, actionButtons: actionButtons, theme: "medical", sortStateOptions: {
                    enabled: true,
                    key: 'covid-medical-follow-up-list'
                } }), (0, jsx_runtime_1.jsx)(PersonDetailsDrawer_1.default, { id: person === null || person === void 0 ? void 0 : person.mit_id, show: showPerson, onClose: viewPersonClose }), (0, jsx_runtime_1.jsx)(ChangeHoldStatus_1.default, { show: showEdit, person: editRecord, onClose: editHoldStatusClose })] }));
};
exports.FollowUpList = (0, react_router_dom_1.withRouter)((0, mobx_react_1.inject)("peopleStore", "holds", "covidNav")((0, mobx_react_1.observer)(FollowUpListComponent)));
